import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string | JSX.Element;
  variation?:
    | 'primary'
    | 'secondary'
    | 'file-upload'
    | 'edit'
    | 'login'
    | 'file-select'
    | 'thumbnail-upload'
    | 'filter';
  size?: 'small';
}

export default function Button({
  label,
  variation = 'primary',
  size,
  ...props
}: ButtonProps) {
  return (
    <button className={`btn btn-${variation} btn-${size}`} {...props}>
      {label}
    </button>
  );
}
